import { Injectable } from '@angular/core';
import { Resolve, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import 'rxjs/observable/fromPromise';
import { DataService } from '../../core/data.service';

@Injectable()
export class TourResolver implements Resolve<any> {

  constructor(private dataService: DataService) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<any> {
    let deviceId = +route.queryParamMap.get('deviceId');
    let tourId = +route.queryParamMap.get('tourId');

    if (deviceId && tourId) {
      return this.dataService.getTour(deviceId, tourId);
    }

    return Promise.resolve(null);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/resolvers/tour.resolver.ts